import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'byte',
  standalone: true,
})
export class BytePipe implements PipeTransform {
  /**
   *
   * @param value array of values to be filtered
   * @result filtered values
   */

  transform(bytes): any {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      return '-';
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let number = Math.floor(Math.log(bytes) / Math.log(1024));
    let resultBytes = bytes / Math.pow(1024, Math.floor(number));
    if (resultBytes >= 1000) {
      number = number + 1;
      resultBytes = 1;
    }
    return resultBytes.toFixed(resultBytes < 10 ? 1 : 0) + ' ' + units[number];
  }
}
